export const environment = {
  AES_KEY: "45b0f84f86aa2e16c46ea766a673754d4fa4f6ab26d66714aa174bf245cf0b60",
  AES_IV: "d024ffd1c6d8a12cc5ac8f14b3480df6",

  mocks: false,
};
